// extracted by mini-css-extract-plugin
export default {"container":"pGX0W___Checkbox-module__container"};